import Layout from "./Layout";
import {
  AlertColor,
  Box,
  Container,
  Grid,
  Paper,
  Snackbar,
} from "@mui/material";
import PageHeading from "../common/pageHeading/PageHeading";
import React, { MouseEvent, useEffect } from "react";
import pageStyles from "./pageStyles";
import useSession from "../effects/useSession";
import { useHistory } from "react-router-dom";
import { History, LocationState } from "history";
import { useDispatch, useSelector } from "react-redux";
import { clearNotification } from "../store/workspace/workspaceSlice";
import { Alert } from "@mui/lab";
import { ApplicationState } from "../store";
import ProgressIndicator from "../common/progressIndicator/ProgressIndicator";

type ActionHandler = (history: History) => void;

interface Props {
  entity?: string;
  heading: string;
  actions?: { label: string; handler: ActionHandler }[];
  loading?: boolean;
  children: React.ReactNode;
}
const PageLayout = (props: Props) => {
  const dispatch = useDispatch();
  const status = useSelector<ApplicationState>(
    (store) => store.workspace.status
  );
  const message = useSelector<ApplicationState>(
    (store) => store.workspace.message
  );

  const { entity, heading, children, loading } = props;
  const actions = props.actions ?? [];

  const history = useHistory<LocationState>();
  const classes = pageStyles();
  const session = useSession();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(clearNotification());
    }, 5000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [status]);

  const mouseListenerWrapper = (
    handler: ActionHandler,
    history: History<LocationState>
  ) =>
    handler
      ? (event: MouseEvent) => {
          handler(history);
        }
      : undefined;

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading
                  entity={entity}
                  heading={heading}
                  primaryButtonText={actions[0]?.label}
                  primaryButtonClickHandler={mouseListenerWrapper(
                    actions[0]?.handler,
                    history
                  )}
                  secondaryButtonText={actions[1]?.label}
                  secondaryButtonClickHandler={mouseListenerWrapper(
                    actions[1]?.handler,
                    history
                  )}
                />
              </Paper>
              {loading ? <ProgressIndicator /> : <Box my={2}>{children}</Box>}
            </Grid>
          </Grid>
          <Snackbar
            open={status != null}
            autoHideDuration={5000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            onClose={() => {
              dispatch(clearNotification());
            }}
          >
            <Box boxShadow={2}>
              <Alert severity={status as AlertColor}>{message as string}</Alert>
            </Box>
          </Snackbar>
        </Container>
      </main>
    </Layout>
  );
};

export default PageLayout;
